import PropTypes from "prop-types";

/**
 * Highlights all occurrences of `highlight` inside `text` (case-insensitive).
 * Renders plain text when there is nothing to highlight.
 */
const HighlightText = ({ text, highlight }) => {
  if (!text) return null;

  const str = String(text);

  if (!highlight?.trim()) return <span aria-label={str}>{str}</span>;

  const regex = new RegExp(
    `(${highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
    "gi",
  );
  const parts = str.split(regex);

  return (
    <span aria-label={str}>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <mark
            key={`mark-${i}`}
            className="bg-yellow-200 text-black rounded-sm px-0"
          >
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </span>
  );
};

HighlightText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  highlight: PropTypes.string,
};

export default HighlightText;
